/*
 * @description: 
 * @author: Jason Wong
 * @since: 2024-07-11 10:32:24
 */
import layoutView from "@/views/layout/Layout";
import indexView from "@/views/home/index";
import LayoutEX from "@/views/layout/LayoutEx";
import pathConfigures from "../../configs/pathConfigures";

export default {
  name: "home",
  path: pathConfigures.prefixUrl + "/home",
  component: LayoutEX,
  children: [
    {
      name: "homeIndex",
      path: "",
      component: indexView,
      meta: { hide: true },
    },
    {
      path: "userSetting/security",
      component: () => import("@/views/home/userSetting"),
      props: true,
      meta: { title: "用户设置", hide: true },
    },
    {
      path: "userSetting/userInfo",
      component: () => import("@/views/home/userSetting"),
      props: true,
      meta: { title: "用户设置", hide: true },
    },
    {
      path: "userSetting/resource",
      component: () => import("@/views/home/userSetting"),
      props: true,
      meta: { title: "用户设置", hide: true },
    },
  ],
  meta: {
    title: "",
    jumpable: true,
  },
};
